module.exports = __webpack_public_path__ + "static/media/subhi-alb.baf748dc.webp";